module.exports = __webpack_public_path__ + "static/machine-installation-8-23a54e033472a16bd2a82cf99883cee0.jpg";